// Returns a random integer between min (include) and max (include)
export function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}


// WEBPACK FOOTER //
// ./src/modules/RandomInt.js